import { connect } from 'react-redux'
import ApplicationOfferDetail from '../../components/ApplicationOffers/ApplicationOfferDetail/ApplicationOfferDetail'
import {
    getApplicationOfferById,
    getApplicationOfferAvailableSummary,
    getApplicationOfferSummary,
    getApplicationOfferOwnerSummary,
    getApplicationOfferSummaryInfo,
    requestApplicationOfferInfo,
    getApplicationOfferSummaryReportByEntity,
    getApplicationOfferAvailableSummaryForComponents,
    getApplicationOfferBusinessReportSummary,
    getApplicationOfferOwnerReportSummary
} from 'actions/applicationOffers'

function mapStateToProps(stateProps, ownProps) {
    return {
        roxMatchId: ownProps.match?.params?.roxMatchId,
        applicationOfferDetail: stateProps.applicationOffers?.applicationOfferDetail,
        availableSummary: stateProps.applicationOffers?.availableSummary,
        summaryData: stateProps.applicationOffers?.summaryData,
        ownerSummaryData: stateProps.applicationOffers?.ownerSummaryData
    }
}

function mergeProps(stateProps, dispatchProps, ownProps) {
    return {
        ...ownProps,
        ...stateProps,
        ...dispatchProps,
        getApplicationOfferSummaryInfo,
        requestApplicationOfferInfo,
        getApplicationOfferSummaryReportByEntity,
        getApplicationOfferAvailableSummaryForComponents,
        getApplicationOfferBusinessReportSummary,
        getApplicationOfferOwnerReportSummary
    }
}

export default connect(
    mapStateToProps,
    {
        getApplicationOfferById,
        getApplicationOfferAvailableSummary, 
        getApplicationOfferSummary,
        getApplicationOfferOwnerSummary
    },
    mergeProps
)(ApplicationOfferDetail)